/* ── Waco Diamonds — Carat Size slider (progressive enhancement) ──────────────────
   Replaces the 9 Carat Size pills with an accessible range slider that snaps to the
   9 discrete carat values. It drives the EXISTING carat radios: on change it checks the
   matching radio and dispatches a bubbling 'change', so the stock <variant-picker> /
   <product-page> resolves the correct variant among ALL combinations (Metal Karat +
   Diamond Quality + Carat). Price, availability, and Add to Cart stay in sync exactly as
   the pills did — the slider is only a new input driving the same variant state.
   No-JS fallback: the original pills remain usable (they are only hidden once JS runs). */
(function () {
  'use strict';
  if (window.__wacoCaratSlider) return;
  window.__wacoCaratSlider = true;

  // Persistent marker on <html>. The pill fallback is hidden via this class, NOT via a
  // field-level class, so when Section Rendering swaps in a fresh (pills-visible) picker
  // fragment the pills stay hidden by CSS immediately — no flash of the old options.
  document.documentElement.classList.add('waco-carat-js');

  function announce(v) { return v + (v === '1' ? ' carat' : ' carats'); }

  function enhance(field) {
    if (field.dataset.wacoCaratEnhanced === '1') return;
    var radios = Array.prototype.slice.call(
      field.querySelectorAll('input.waco-radio[data-option-name="Carat Size"]')
    );
    if (radios.length < 2) return;

    var values = radios.map(function (r) { return r.value; });
    var last = radios.length - 1;
    var checkedIndex = radios.findIndex(function (r) { return r.checked; });
    if (checkedIndex < 0) checkedIndex = 0;

    field.dataset.wacoCaratEnhanced = '1';
    field.classList.add('waco-field--carat-enhanced');
    // Keep the radios as the value store, but out of the tab order — the slider is the control.
    radios.forEach(function (r) { r.setAttribute('tabindex', '-1'); });

    // Grouped control container (bordered) so the slider + ticks read as one unit that
    // clearly belongs to the Carat Size field.
    var slider = document.createElement('div');
    slider.className = 'waco-carat-slider';

    var track = document.createElement('div');
    track.className = 'waco-carat-slider__track';

    var range = document.createElement('input');
    range.type = 'range';
    range.className = 'waco-carat-range';
    range.min = '0';
    range.max = String(last);
    range.step = '1';
    range.value = String(checkedIndex);
    range.setAttribute('aria-label', 'Carat Size');

    // Ruler treatment (client request): a vertical tick line painted on the track
    // at each snap position — taller at whole carats, shorter at halves — so the
    // capsule reads like a carat ruler. Painted as background layers on the input
    // itself so the thumb always slides OVER them. Tick centers track the thumb
    // path: 10px track padding + half the 24px thumb, minus the 2px tick tile
    // (background-position % resolves against width - tile). The identical
    // treatment renders on the collection cards (waco-card-configurator.js) so
    // carat selection reads the same everywhere.
    var tickImgs = [], tickPos = [], tickSizes = [];
    for (var d = 0; d <= last; d++) {
      var f = last ? d / last : 0.5;
      var whole = parseFloat(values[d]) % 1 === 0;
      var ink = whole ? 'rgba(51,54,36,0.42)' : 'rgba(51,54,36,0.24)';
      tickImgs.push('linear-gradient(' + ink + ',' + ink + ')');
      tickPos.push('calc(21px + (100% - 42px) * ' + f.toFixed(4) + ') 50%');
      tickSizes.push(whole ? '2px 18px' : '2px 10px');
    }
    range.style.backgroundImage = tickImgs.join(',');
    range.style.backgroundPosition = tickPos.join(',');
    range.style.backgroundSize = tickSizes.join(',');
    range.style.backgroundRepeat = 'no-repeat';

    var scale = document.createElement('div');
    scale.className = 'waco-carat-slider__scale';
    values.forEach(function (v, i) {
      var tick = document.createElement('button');
      tick.type = 'button';
      tick.className = 'waco-carat-tick';
      tick.innerHTML = '<span class="waco-carat-tick__dot" aria-hidden="true"></span><span class="waco-carat-tick__num">' + v + '</span>';
      tick.setAttribute('aria-label', announce(v));
      tick.addEventListener('click', function () { setIndex(i, true); });
      scale.appendChild(tick);
    });

    track.appendChild(range);
    slider.appendChild(track);
    slider.appendChild(scale);

    // Ruler numbers: a label under each whole-carat tick, positioned on the same
    // thumb-path math as the ticks (" ct" on the last one names the unit).
    var labels = document.createElement('div');
    labels.className = 'waco-carat-rulerlabels';
    labels.setAttribute('aria-hidden', 'true');
    var wholes = [];
    values.forEach(function (v, i) { if (parseFloat(v) % 1 === 0) wholes.push(i); });
    if (wholes.length < 2) wholes = [0, last]; // fallback: anchor min/max
    wholes.forEach(function (i, w) {
      var s = document.createElement('span');
      s.textContent = values[i] + (w === wholes.length - 1 ? ' ct' : '');
      s.style.left = 'calc(21px + (100% - 42px) * ' + (last ? i / last : 0.5).toFixed(4) + ')';
      labels.appendChild(s);
    });
    slider.appendChild(labels);

    var optionsDiv = field.querySelector('.waco-options--carat');
    if (optionsDiv) { optionsDiv.parentNode.insertBefore(slider, optionsDiv); }
    else { field.appendChild(slider); }

    // The selected value is shown once, by the stock field legend ("Carat Size: 1.5"),
    // so the slider carries no duplicate number — only the accessible aria-valuetext.
    function reflect(i) {
      range.value = String(i);
      range.setAttribute('aria-valuetext', announce(values[i]));
      var ticks = scale.querySelectorAll('.waco-carat-tick');
      for (var t = 0; t < ticks.length; t++) ticks[t].classList.toggle('is-active', t === i);
    }

    function setIndex(i, fire) {
      i = Math.max(0, Math.min(last, i));
      reflect(i);
      var radio = radios[i];
      if (radio && !radio.checked) {
        radio.checked = true;
        if (fire) radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    range.addEventListener('input', function () { setIndex(parseInt(range.value, 10), true); });

    // If the carat selection changes elsewhere (carried selection, re-render), follow it.
    field.addEventListener('change', function (e) {
      var r = e.target;
      if (r && r.classList && r.classList.contains('waco-radio') && r.checked) {
        var idx = radios.indexOf(r);
        if (idx >= 0 && String(idx) !== range.value) reflect(idx);
      }
    });

    reflect(checkedIndex);
  }

  function enhanceAll() {
    var fields = document.querySelectorAll('[data-waco-field="Carat Size"]');
    for (var i = 0; i < fields.length; i++) enhance(fields[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceAll);
  } else {
    enhanceAll();
  }

  // Re-enhance if Section Rendering replaces the picker DOM. Coalesced to one rebuild per
  // frame via requestAnimationFrame, which runs before paint — so the slider is back in
  // place before the browser repaints, with no visible gap (pills stay hidden by CSS).
  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    var run = function () { scheduled = false; enhanceAll(); };
    if (window.requestAnimationFrame) requestAnimationFrame(run); else setTimeout(run, 0);
  }
  var mo = new MutationObserver(schedule);
  if (document.body) mo.observe(document.body, { childList: true, subtree: true });
})();
